import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {AccessRights} from "lib/constants/accessRights";
import MainPageComponent from "./main.component";
import LoadingComponent from "components/loading";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";

function MainPageContainer() {
  const hasStockflowViewAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.TrackcoPortal.CHECKOUT));
  const lang = useSelector((state) => state.constant.languages);
  const history = useHistory();

  useEffect(() => {
    if (!hasStockflowViewAccessRight) {
      history.push("/admin/dashboard");
    }
  }, [history, hasStockflowViewAccessRight]);

  if (!hasStockflowViewAccessRight) return <LoadingComponent />;

  return (
    <>
      <MainPageComponent lang={lang} />
    </>
  );
}

export default MainPageContainer;
